document.addEventListener('DOMContentLoaded', function() {
  var mountInquiryDrawersAtPageRoot = function(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var drawers = scope.querySelectorAll(
      'side-drawer.product-popup-modal__drawer--keep'
    );

    drawers.forEach(function(drawer) {
      if (drawer.parentElement !== document.body) {
        document.body.appendChild(drawer);
      }
    });
  };

  mountInquiryDrawersAtPageRoot(document);

  document.addEventListener('shopify:section:load', function(event) {
    mountInquiryDrawersAtPageRoot(event.target);
  });

  var successMessage = document.querySelector(
    '[data-contact-form-type="ask-an-expert"] .form-success'
  );
  var forms = document.querySelectorAll('[data-contact-form-type="ask-an-expert"]');

  var readCurrentConfiguration = function(wrapper) {
    var groups = document.querySelectorAll(
      '[data-airzoe-linked-options] .airzoe-option-group'
    );
    var values = [];

    groups.forEach(function(group) {
      var legend = group.querySelector('legend');
      var active = group.querySelector('.airzoe-option.is-active span');

      if (legend && active) {
        values.push(
          legend.textContent.trim() +
            ': ' +
            active.textContent.replace('✓', '').trim()
        );
      }
    });

    if (values.length) return values.join(' | ');

    var field = wrapper.querySelector('[data-inquiry-field="configuration"]');
    return field ? field.dataset.defaultValue || field.value : '';
  };

  var readCurrentQuantity = function() {
    var inputs = document.querySelectorAll(
      '.product-form__quantity input[name="quantity"]'
    );

    for (var index = 0; index < inputs.length; index += 1) {
      if (!inputs[index].disabled && inputs[index].offsetParent !== null) {
        return inputs[index].value || '1';
      }
    }

    return inputs.length ? inputs[0].value || '1' : '1';
  };

  var updateField = function(wrapper, name, value) {
    var field = wrapper.querySelector('[data-inquiry-field="' + name + '"]');
    var display = wrapper.querySelector('[data-inquiry-display="' + name + '"]');

    if (field) field.value = value;
    if (display) display.textContent = value || 'As shown on this product page';
  };

  var syncInquiryDetails = function(wrapper) {
    updateField(
      wrapper,
      'configuration',
      readCurrentConfiguration(wrapper) || 'As shown on this product page'
    );
    var quantityField = wrapper.querySelector('[data-inquiry-field="quantity"]');
    if (!quantityField || quantityField.dataset.userEdited !== 'true') {
      updateField(wrapper, 'quantity', readCurrentQuantity());
    }
  };

  var syncAllInquiryDetails = function() {
    forms.forEach(syncInquiryDetails);
  };

  forms.forEach(function(wrapper) {
    var submit = wrapper.querySelector('button[type="submit"]');
    if (!submit) return;

    var hasEmail = !!wrapper.querySelector('[data-field-name="email"]');
    submit.disabled = !hasEmail;
    submit.setAttribute('aria-disabled', (!hasEmail).toString());
    wrapper.classList.toggle('ask-an-expert--disabled', !hasEmail);
    syncInquiryDetails(wrapper);

    var contactForm = wrapper.querySelector('form');
    if (contactForm) {
      contactForm.addEventListener('input', function(event) {
        if (!event.target.matches('[data-inquiry-field="quantity"]')) return;
        event.target.dataset.userEdited = 'true';
        var display = wrapper.querySelector('[data-inquiry-display="quantity"]');
        if (display) display.textContent = event.target.value || '1';
      });

      contactForm.addEventListener('submit', function() {
        syncInquiryDetails(wrapper);
      });
    }
  });

  document.addEventListener('input', function(event) {
    if (event.target.matches('input[name="quantity"]')) {
      syncAllInquiryDetails();
    }
  });

  document.addEventListener('change', function(event) {
    if (event.target.matches('input[name="quantity"]')) {
      syncAllInquiryDetails();
    }
  });

  document.addEventListener('click', function(event) {
    if (!event.target.closest('.quantity__button')) return;
    window.setTimeout(syncAllInquiryDetails, 0);
  });

  document.addEventListener('variant:update', function(event) {
    var variant = event.detail && (event.detail.variant || event.detail.resource);

    if (variant) {
      forms.forEach(function(wrapper) {
        if (variant.sku) updateField(wrapper, 'sku', variant.sku);

        var variantId = wrapper.querySelector(
          '[data-inquiry-field="variant-id"]'
        );
        if (variantId && variant.id) variantId.value = variant.id;
      });
    }

    syncAllInquiryDetails();
  });

  if (!successMessage) return;

  var openPopup = function() {
    var popup =
      successMessage.closest('[id^="PopupModal-"]') ||
      successMessage.closest('side-drawer');
    if (!popup) return;

    if (typeof popup.open === 'function') {
      popup.open();
    } else {
      popup.setAttribute('open', 'true');
    }

    popup.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };

  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1 && node.classList.contains('form-success')) {
          openPopup();
        }
      });
    });
  });

  observer.observe(successMessage, { childList: true, subtree: true });
  openPopup();
});
